import React, { Component } from "react";
import "./form-builder-section.sass";
import { ConnectFormBuilderBox } from "./connect-form-builder-box/connect-form-builder-box";
import { EditFormBuilderContent } from "./edit/edit-form-builder-content";
import { EditFormBuilderStyles } from "./edit/edit-form-builder-styles";
import { PageSectionHoc } from "../../../../../../components/HOC/page-section/page-section.hoc";
import { EditModalSwitcher } from "../../../../../../components/edit-modal/edit-modal-switcher/edit-modal-switcher";
import { EditModal } from "../../../../../../components/edit-modal/edit-modal/edit-modal";
import { EditModalStep } from "../../../../../../components/edit-modal/edit-modal-step/edit-modal-step";
import ColorParser from "../../../../../../services/color-parser/color-parser";
import { connect } from "react-redux";
import { Config } from "../../../../../../utils/config";
import { tintFormTagName } from "../../../../../form-builder/utils/form-builder.types";
import {
  formAttributes
} from "../../../../../../../../../client-scripts/form-builder/services/form-element-properties.service";
const experienceBuilderFormId = "tint-form-builder";
class FormBuilderSection extends Component {
  constructor(props, context) {
    super(props, context);
    this.formWrapperRef = React.createRef();
  }
  initFormBuilderScript() {
    const src = `${Config.getEnvironmentVariable("BASE_URL")}/dist/tint.js`;
    const script = document.querySelector(`script[src='${src}']`);
    if (!script) {
      const script2 = document.createElement("script");
      script2.src = src;
      script2.onload = () => {
        this.createForm();
      };
      document.body.appendChild(script2);
    }
  }
  componentDidMount() {
    this.initFormBuilderScript();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data.content.formBuilderId !== this.props.data.content.formBuilderId) {
      const form = document.querySelector(`#${experienceBuilderFormId}`);
      form.remove();
      this.createForm();
    }
  }
  getRectangleBox(isSmallFirst) {
    return /* @__PURE__ */ React.createElement("div", { className: "rectangle-container__rectangle-box" }, /* @__PURE__ */ React.createElement("div", { className: `rectangle ${isSmallFirst ? "rectangle--small" : ""}` }), /* @__PURE__ */ React.createElement("div", { className: `rectangle ${!isSmallFirst ? "rectangle--small" : ""}` }));
  }
  renderContent() {
    return /* @__PURE__ */ React.createElement("div", { className: "rectangle-container" }, /* @__PURE__ */ React.createElement(ConnectFormBuilderBox, { onClick: this.props.openModal.bind(this), text: "+ Connect Form Builder" }), this.getRectangleBox(true), this.getRectangleBox(false), this.getRectangleBox(true), this.getRectangleBox(false), this.getRectangleBox(true));
  }
  createForm() {
    const tintForm = document.createElement(tintFormTagName);
    tintForm.setAttribute(formAttributes.teamId, this.props.data.content.teamId);
    tintForm.setAttribute(formAttributes.formId, this.props.data.content.formBuilderId);
    tintForm.setAttribute(formAttributes.metadata, `reward_id=${this.props.data.content.loyalty_activity_id}`);
    tintForm.id = experienceBuilderFormId;
    this.formWrapperRef.current.appendChild(tintForm);
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        dir: "auto",
        className: `tint-page-section tint-page-section--form-builder ${this.props.getSectionClass()}`,
        ref: this.formWrapperRef,
        style: {
          backgroundColor: ColorParser.defaultColor(this.props.data.styles.backgroundColor),
          paddingTop: `${this.props.data.styles.sectionPadding}px`,
          paddingBottom: `${this.props.data.styles.sectionPadding}px`,
          display: !this.props.data.content.formBuilderId && this.props.isPreviewMode ? "none" : ""
        }
      },
      this.props.renderGenericComponents(),
      this.props.isModalOpen && /* @__PURE__ */ React.createElement(
        EditModal,
        {
          isVisible: this.props.isModalOpen,
          saveData: this.props.onDataSave,
          closeModal: this.props.closeModal,
          dismissModal: this.props.dismissModal
        },
        /* @__PURE__ */ React.createElement(EditModalStep, { title: "Edit Form" }, /* @__PURE__ */ React.createElement(EditModalSwitcher, null, /* @__PURE__ */ React.createElement(
          EditFormBuilderContent,
          {
            updateForm: this.onDataSave,
            data: this.props.data,
            dataUpdate: this.props.onContentUpdate
          }
        ), /* @__PURE__ */ React.createElement(
          EditFormBuilderStyles,
          {
            data: this.props.data,
            saveData: this.props.onDataSave,
            dataUpdate: this.props.onContentUpdate,
            styleDataUpdate: this.props.onStylesUpdate
          }
        )))
      ),
      !this.props.data.content.formBuilderId ? this.renderContent() : null
    );
  }
}
const mapStateToProps = (state) => ({
  session: state.session.data
});
export default connect(mapStateToProps)(PageSectionHoc(FormBuilderSection));
